import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { colors } from '../utils/colors';

export function ProgressBar({ currentValue, maxValue, color }) {
  return (
    <StyledProgress value={currentValue} max={maxValue} color={color}>
      {currentValue}%
    </StyledProgress>
  );
}

ProgressBar.propTypes = {
  currentValue: PropTypes.number.isRequired,
  maxValue: PropTypes.number,
  color: PropTypes.string,
};

ProgressBar.defaultProps = {
  maxValue: 1,
  color: colors.navyBlue,
};

const StyledProgress = styled.progress`
  width: 100%;
  appearance: none;
  height: 7px;
  border-radius: 100px;
    
  /* Chrome and Safari */
  &::-webkit-progress-bar {
    background: ${colors.lightGrey};
    border-radius: 100px;
  }

  &::-webkit-progress-value {
    background-color: ${(props) => props.color};
     border-top-right-radius: ${(props) =>
       props.currentValue === props.maxValue && '100px'};
    border-bottom-right-radius: ${(props) =>
      props.currentValue === props.maxValue && '100px'};
    border-top-left-radius: 100px;
    border-bottom-left-radius: 100px;
  }

  /* Firefox */
  &::-moz-progress-bar {
    background-color:  ${(props) => props.color};
     border-top-right-radius: ${(props) =>
       props.currentValue === props.maxValue && '100px'};
    border-bottom-right-radius: ${(props) =>
      props.currentValue === props.maxValue && '100px'};
    border-top-left-radius: 100px;
    border-bottom-left-radius: 100px;
`;
